<template lang="html">
  <div
    :class="{
      'tabs__light  ': mode === 'light',
      'tabs__dark ': mode === 'dark',
    }"
  >
    <ul class="flex bg-white items-center">
      <li
        class="py-3 px-0 w-1/2 cursor-pointer text-center"
        v-for="(tab, index) in tabs"
        :key="tab.title"
        @click="selectTab(index)"
        :class="{
          'bg-green-light text-white ': index == selectedIndex,
          'rounded-tl-md': index == selectedIndex && index == 0,
          'rounded-tr-md': index == selectedIndex && index != 0,
        }"
      >
      <span class="relative inline-block">
        {{ tab.title }}
        <span v-if="index !==0 && reqCount" class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">
        {{ reqCount }}
        </span>
      </span>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "light",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    reqCount: {
      type: Number
    }
  },
  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      tabs: [], // all of the tabs
    };
  },
  watch: {
    // isActive(newVal, oldVal) {
    //   this.selectTab(0);
    // },
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.selectTab(0);
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i;
      // loop over all the tabs
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i;
      });
      this.requestRefreshHandler(i)
    },
    requestRefreshHandler (tabIndex) {
      tabIndex === 0 ? this.$store.dispatch('getTrainerMessages', {}) : this.$store.dispatch('getTrainerMessageRequest')
    }
  },
};
</script>